import { dateToString, formatPrice } from "../../../utils/Utils";
import ShoppingCart from "../../../components/shopping-cart/ShoppingCart";
import BillboardCalendar from "../../../components/BillboardCalendar";
import Billboards from "../../../libs/API/Billboards";
import Notification from "../../../components/Notification";


class CampaignPlanningConfirmationBillboardListItem{
    constructor(data){
        this.main = null;
        this._data = data;
        
        this._data.totalDays = (data.dateRange.to.getTime() - data.dateRange.from.getTime())/(1000 * 3600 * 24) + 1;

        this._initDom();
        
        this._daysAvailableBtn = this.main.querySelector('.days_available_btn');
        this._checkboxExclusivity = this.main.querySelector('input[name="exclusivity"]');  

        if (this._checkboxExclusivity) {
          this._checkboxExclusivity.addEventListener('change', this._onCheckboxExclusivityChange.bind(this));
        }

        this._daysAvailableBtn.addEventListener('click', this._onClickDaysAvailableBtn.bind(this));

        if (this.main.querySelector('.delete_btn')) {
          this.main.querySelector('.delete_btn').addEventListener('click', this._onClickDeleteBtn.bind(this));
        }
    }

    _onClickDaysAvailableBtn(e){
        e.preventDefault();
                
        BillboardCalendar.showAvailability(this._data.id, this._data.dateRange, this._data.exclusivity, null, this._data.brand_category_id, this._data.weekdays, true, this._data.package ? this._data.package.id : null);
    }

    _onCheckboxExclusivityChange(e){
        ShoppingCart.changeItemExclusivity(this._data.id, this._data.dateRange, this._checkboxExclusivity.checked, this._data.weekdays, this._data.package ? this._data.package.id : null);
        
        Notification.show('Days available may have changed', null);
    }

    _initDom(){
      let data = this._data;
      
      let daysAvailableText = `${data.days_available} of ${data.totalDays} days available`;
      
      let isStatic = [Billboards.FORMAT_STATIC, Billboards.FORMAT_OTHER_MEDIA].includes(Number(data.format.id));

      let html = /*html*/`<tr class="table__tr ${isStatic ? 'table__tr--static' : ''}">
          <td class="table__td table__td--name">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0"><img src="${CDN_URL}billboards/thumbs/250x141/${data.image}" alt="Billboard" class="table__img"></div>
              <div class="table__main">
                <div class="table__name">${data.name}</div>
                <div class="table__location">${(data.road != null ? data.road.name + '. ': '')}<span class="text-no-wrap">${data.location.name}</span></div>
                ${(data.is_prime ? '<div class="mt-1"><div class="tag tag--size-3 tag--prime">Prime</div></div>' : '')}
              </div>
            </div>
          </td>
          <td class="table__td table__td--period">
          <div class="table__exclusivity">
            ${(data.package ? '' : 
            `<div class="size-11 weight-500 text-no-wrap mr-0 mr-lg-3">I want exclusivity</div>
              <div class="d-flex ml-2 mt-1 mt-lg-0">
                  <label class="form-switcher form-switcher--color-green form-switcher--size-2">
                      <input type="checkbox" class="form-switcher__input" name="exclusivity" ${ data.exclusivity ? 'checked' : ''}>
                      <span class="form-switcher__slider"></span>
                  </label>
              </div>
            </div>`)}
            <div class="table__period mt-1">
              <div>
                <a href="#" class="link table__availability days_available_btn">${daysAvailableText}</a>
              </div>
              <div class="table__date">${dateToString(data.dateRange.from, 'M d')} - ${dateToString(data.dateRange.to, 'M d')}</div>
            </div>
          </td>
          <td class="table__td table__td--pricing">
            <div class="table__original_price">${(data.original_price && data.original_price != data.price ? formatPrice(data.original_price) : '')}</div>
            <div class="table__price price">${formatPrice(data.price)}</div>
          </td>
          <td class="table__td table__td--action">
            ${(data.package ? '' : `<div class="table__remove delete_btn"><i class="material-icons material-icons--type-outlined material-icons--size-3">delete</i></div>`)}
          </td>
        </tr>`;
        
        this.main = document.createElement('tbody');// Lo creo como tbody porque sino no puedo crear tr como firstChild
        this.main.innerHTML = html;
        this.main = this.main.firstChild;
    }

    _onClickDeleteBtn(e){
        ShoppingCart.remove(this._data.id, this._data.dateRange);
    }
}

export default CampaignPlanningConfirmationBillboardListItem;